import React from 'react';
import { Box, Paper, Typography, ThemeProvider, Link } from '@mui/material';
import ResearchTheme from '../styles/Theme.js';


function ExampleResearchPage() {
  // Sample survey data
  const surveys = [
    {
      title: "AI Consumer Trends Study",
      description: "Research on how AI tools affect buying choices.",
      samplesize: "50",
      question: "20",
      
    },
    {
      title: "Green Productss Market Report", 
      description: "Study of consumer willingness to pay for eco-friendly items.",
      samplesize: "200",
      question: "30"
    },
    {
      title: "Online Shopping Experience",
      description: "Research on online buying habits and pain points.",
      samplesize: "500",
      question: "15"
    }
  ];

  return (
    <ThemeProvider theme={ResearchTheme}>
      <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 600, textAlign: 'center', paddingTop: 13 }}>
              Pick a topic
            </Typography>  
      <Box sx={{ 
        padding: 4, 
        paddingTop: 5,
        display: 'flex', 
        flexDirection: 'row',
        gap: 3,
        maxWidth: '1200px',
        margin: '0 auto',
        minHeight: '60vh'
      }}>
        
        
        {surveys.map((survey, index) => (
          
          <Paper 
            key={index}
            elevation={3}
            component={Link}
            href={`/exampleresearch/${survey.title}`}
            sx={{ 
              padding: 3, 
              borderRadius: 2,
              backgroundColor: index % 2 === 0 ? 'secondary.main' : 'white',
              border: '2px solid',
              borderColor: index === 1 ? 'secondary.main' : 'transparent',
              color: 'text.primary',
              transition: 'transform 0.3s',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              textDecoration: 'none',
              '&:hover': {
                transform: 'translateY(-5px)',
                borderColor: 'primary.main'
              }
            }}
          >
            
            <Typography variant="h4" component="h2" sx={{ mb: 2, fontWeight: 500, textAlign: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px', paddingTop: 8}}>
                {survey.title}
              </Box>
            </Typography>
            
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 1, textAlign: 'center', pt: 5 }}>
                Prompt:
            </Typography>
            <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 2, textAlign: 'center', mx: 3}}>
              {survey.description}
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mt: 3, 
              mb: 2 
            }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'rgba(0,0,0,0.1)', 
                  fontWeight: 500,
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                  }
                }}
              >
                <Link href={`/exampleresearch`}>
                  Find out more
                </Link>
              </Typography>
            </Box>
            <Box sx={{ 
              mt: 'auto', 
              display: 'flex', 
              justifyContent: 'space-between', 
              pt: 2, 
              borderTop: '1px solid', 
              borderColor: 'rgba(0,0,0,0.1)',
              marginTop: 'auto'
            }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {survey.samplesize} personas
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {survey.question} questions
              </Typography>
            </Box>
          </Paper> 
        ))}
      </Box>
    </ThemeProvider>
  );
}

export default ExampleResearchPage;